/* eslint-disable */
import * as React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

type HeaderProps = {
  text: string;
  icon: any;
  onClick: any;
  active: boolean;
};

export const SideItem: React.FC<HeaderProps> = (props) => {
  return (
    <ListItem
      button
      style={{
        color: props.active ? '#ffffff' : '#ffffff99',
        paddingLeft: 36,
        paddingTop: 10,
        paddingBottom: 10,
        borderLeftWidth: 4,
        borderLeftColor: props.active ? '#ffffff' : 'transparent',
        borderLeftStyle: 'solid',
        cursor: 'pointer',
      }}
      onClick={props.onClick}
    >
      <ListItemIcon
        style={{ color: props.active ? '#ffffff' : '#ffffff99', minWidth: 40 }}
      >
        {props.icon}
      </ListItemIcon>
      <ListItemText primary={props.text} />
    </ListItem>
  );
};
